import { useMutation } from "@tanstack/react-query";

export const mutateInstantBrandAI = (initParams = {}) => {

    const mutation = useMutation({
        mutationKey: ['mutate-instant-brand-ai', initParams],
        mutationFn: async (params = {}) => {
            const res = await axios.get(route('studio.v1.api.instant.brand.show'), {
                params: {
                    ...initParams,
                    ...params
                }
            });

            // AD-105: slogan generation is removed from the Social-to-Display flow.
            // Only images, caption, favicon, advertiser and brand colors are used;
            // the second (slogansOnly) AI call is intentionally not made.
            res.data.slogans = {};

            return res;
        },
    });

    return mutation;
} 